<template>
  <div
    class="questionListContainer"
    :class="
      animation
        ? ['questionListContainerTrue', 'questionListHideAnimation']
        : ['questionListContainerFalse', 'questionListUnHideAnimation']
    "
  >
    <div
      ref="questionList"
      class="questionList"
      :class="
        animation ? 'questionListHideAnimation' : 'questionListUnHideAnimation'
      "
    >
      <div v-for="item in mcqs.questions" :key="item.id">
        <MCQQuestion
          :ref="'question' + item.id"
          :item="item"
          :is-current="item.number - 1 === mcqs.current"
          @changeCurrent="changeCurrent"
        ></MCQQuestion>
      </div>
    </div>
    <img
      v-if="!hide"
      src="../assets/Collapse.svg"
      class="hideList unHideImage"
      :class="hide ? 'hideListTrue' : 'hideListFalse'"
      @click="animation = !animation"
    />
    <img
      v-else
      src="../assets/Expand.svg"
      class="hideList hideImage"
      :class="hide ? 'hideListTrue' : 'hideListFalse'"
      @click="animation = !animation"
    />
    <div class="verticalLine"></div>
  </div>
</template>

<script>
import MCQQuestion from './MCQQuestion'
export default {
  name: 'QuestionsList',
  components: { MCQQuestion },
  props: ['mcqs'],
  data: function() {
    return {
      animation: false,
    }
  },
  computed: {
    hide() {
      return this.animation
    },
  },
  updated() {
    var x = this.$refs[
      'question' + this.mcqs.questions[this.mcqs.current].id
    ][0].$el
    const elementRect = x.getBoundingClientRect()
    const questionList = this.$refs.questionList

    questionList.scrollTop =
      x.offsetTop -
      64 -
      questionList.getBoundingClientRect().height / 4 +
      elementRect.height
  },
  methods: {
    changeCurrent: function(newCurrent) {
      this.$emit('changeCurrent', newCurrent)
    },
  },
}
</script>
<style scoped>
.verticalLine {
  width: 1px;
  background: #a8b2c6;
}
::-webkit-scrollbar {
  width: 4px;
  height: 5px;
}

::-webkit-scrollbar-thumb {
  background-color: #d0d0d0;
}
.hideList {
  z-index: 1;
  cursor: pointer;
  margin: auto;
  display: flex;
  align-items: center;
  width: 16px;
  height: 50px;
}
.hideListTrue {
  margin-right: 4px;
}
.hideListFalse {
  margin-left: -16px;
}
.questionListHideAnimation {
  animation-name: hideAni;
  animation-duration: 0.5s;
  animation-iteration-count: 1;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
}

.questionListUnHideAnimation {
  animation-name: UnhideAni;
  animation-duration: 0.5s;
  animation-iteration-count: 1;
  animation-timing-function: ease-in-out;
}
.questionListContainer {
  display: flex;
  flex-direction: row;
}
.questionListContainerTrue {
  background: rgba(168, 178, 198, 0.5);
}
.questionListContainerFalse {
  background: #ffffff;
}
@keyframes hideAni {
  0% {
    width: 360px;
  }
  100% {
    width: 20px;
  }
}

@keyframes UnhideAni {
  0% {
    width: 20px;
  }
  100% {
    width: 360px;
  }
}

@media only screen and (max-width: 1440px) {
  @keyframes hideAni {
    0% {
      width: 280px;
    }
    100% {
      width: 20px;
    }
  }

  @keyframes UnhideAni {
    0% {
      width: 20px;
    }
    100% {
      width: 280px;
    }
  }
}
@keyframes hideImageAni {
  0% {
    margin-right: -16px;
  }
  100% {
    margin-right: 20px;
  }
}

@keyframes UnhideImageAni {
  0% {
    margin-right: 0px;
  }
  100% {
    margin-left: -16px;
  }
}

.hideImage {
  animation-name: hideImageAni;
  animation-duration: inherit;
  animation-iteration-count: inherit;
  animation-timing-function: inherit;
}
.unHideImage {
  animation-name: UnhideImageAni;
  animation-duration: inherit;
  animation-iteration-count: inherit;
  animation-timing-function: inherit;
}
.questionList {
  width: 360px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  background: #ffffff;
}

@media only screen and (max-width: 1440px) {
  .questionList {
    width: 280px;
  }
}
</style>
